import { faCheckCircle, faPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '@nexelem/deprecated-theme';
import { IconButton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { openEditAvailabilityModal } from '../modals';

const MOCK_QUEUE = {
  name: 'Obszar fioletowy 2',
  id: 'OBSZ_FIO2',
  area: 'Obszar fioletowy',
};

export const QueueAvailability = () => {
  const { tWrapper } = useCustomTranslation('common');
  return (
    <div className="flex h-15 items-center justify-between border-t border-border-container bg-surface-container px-2 has-[:checked]:bg-surface-focus-lighter">
      <div>
        <Checkbox disableRipple size="small" />
        <span className="ml-2 text-s18">
          {MOCK_QUEUE.name} ({MOCK_QUEUE.id})
        </span>
      </div>

      <div className="flex items-center gap-2">
        <FontAwesomeIcon className="text-icon-dark" icon={faCheckCircle} />
        <span className="text-s18">{tWrapper('available')}</span>
        <span className="text-s18-spaced">06:30 - 14:30</span>
      </div>

      <IconButton
        Icon={() => <FontAwesomeIcon className="text-icon-action" icon={faPen} onClick={openEditAvailabilityModal} />}
      />
    </div>
  );
};
